<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>Branches Stock</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row dense>
                    <v-col cols="12" xs="12" md="12">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-autocomplete autocomplete="off" dense outlined v-model="selectedCustomer"
                                    :items="customers" label="Select Customer" item-text="Name" item-value="id"
                                    :search-input.sync="searchCustomers"
                                    @change="getBranches(selectedCustomer)"></v-autocomplete>
                            </v-col>

                            <v-col cols="12" xs="12" md="6">
                                <v-autocomplete name="checkStockStore" dense outlined v-model="queryStore"
                                    :items="stores" label="Select Shop" item-text="Name" item-value="id"
                                    @change="queryData"></v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="6">
                                <!-- excel icon -->
                                <download-excel :data="inventory" :fields="fields" name="Stock List">
                                    <v-icon color="green">mdi-file-excel</v-icon>
                                </download-excel>
                                <!-- end -->
                            </v-col>

                            <v-col cols="12" style="margin-top: -20px">
                                <v-text-field name="checkStockSearch" outlined dense label="Search"
                                    v-model="search"></v-text-field>
                                <!-- start of table -->
                                <v-data-table :loading="loader" :mobile-breakpoint="0" loading-text="Loading Data......"
                                    :headers="headers" :items="inventory" :search="search" :items-per-page="2000">
                                    <template v-slot:item.product.Name="{ item }">
                                        <v-btn v-if="item.product" color="primary" text
                                            :to="`/quick-audit/${item.product.id}`">{{
                                                item.product.Name }}</v-btn>
                                    </template>

                                </v-data-table>
                                <!-- end -->
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <!-- snackbar -->
            <snackbar ref="snackbar"></snackbar>
        </v-card>
    </v-container>
</template>


<script>
export default {
    computed: {
        activeStore() {
            return localStorage.getItem("store_id");
        },
    },
    data() {
        return {
            search: null,
            searchCustomers: null,
            selectedCustomer: {},
            pageItems: 500,
            loader: false,
            editItem: {},
            damagedItem: {},
            transferItem: {},
            store: null,
            queryStore: null,
            customers: [],
            stores: [],
            users: [],
            date: null,
            dialog: false,
            damageDialog: false,
            transferDialog: false,
            headers: [
                { text: "Item Code", value: "product.ItemCode" },
                { text: "Product Name", value: "product.Name" },
                { text: "Available Qty", value: "AvailableQty" },
            ],
            fields: {
                Product: "product.Name",
                AvailableQty: "AvailableQty",
            },
            inventory: [],
        };
    },
    watch: {
        searchCustomers(val) {
            if (val && val !== this.select && this.queryCustomers(val)) {
                this.queryCustomers(val);
            }
        }
    },
    methods: {
        queryCustomers(searchText) {
            const self = this;
            const url = "/customers/search";
            const data = {
                searchText: searchText
            };

            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        // if array length > 1
                        self.customers = res.ResponseData;
                    } else {
                        self.$store.commit("btnLoader", false);
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch(err => {
                    self.$store.commit("btnLoader", false);
                    this.$refs.snackbar.show(err, "red");
                });
        },
        queryData() {
            const id = this.queryStore;
            const self = this;
            self.loader = true;
            this.$store
                .dispatch("get", `/inventory/${id}`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        self.inventory = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getBranches(id) {
            const self = this;
            var url = `/stores/customers/${id}`;
            this.$store
                .dispatch("get", url)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.stores = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getStores() {
            const self = this;
            this.$store
                .dispatch("get", `/stores`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.stores = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
    },
    created() {
        Promise.all([this.getStores()]);
    },
};
</script>

<style lang="scss" scoped></style>